import React from 'react';
export const DosageSection = () => {
  return <section id="dosage" className="w-full py-12 bg-green-900/10" data-id="element-93">
      <div className="container mx-auto px-4" data-id="element-94">
        <h2 className="text-2xl md:text-3xl font-bold text-green-900 mb-6 text-center" data-id="element-95">
          How Much Does Your Dog Weigh?
        </h2>
        <p className="text-green-900/80 mb-8 text-center max-w-3xl mx-auto" data-id="element-96">
          The Daily Foundation Chew™ is scientifically formulated for optimal
          results based on your dog's size:
        </p>
        <div className="overflow-x-auto mb-8" data-id="element-97">
          <table className="min-w-full bg-amber-50 border-collapse rounded-lg shadow-md" data-id="element-98">
            <thead data-id="element-99">
              <tr className="bg-green-900 text-amber-50" data-id="element-100">
                <th className="p-4 text-left" data-id="element-101">Your Dog's Weight</th>
                <th className="p-4 text-center" data-id="element-102">Daily Serving</th>
                <th className="p-4 text-center" data-id="element-103">Monthly Supply Needed</th>
              </tr>
            </thead>
            <tbody data-id="element-104">
              <tr className="border-b border-green-900/10" data-id="element-105">
                <td className="p-4 text-green-900 font-semibold" data-id="element-106">
                  Under 25 lbs
                </td>
                <td className="p-4 text-center" data-id="element-107">1/2 chew</td>
                <td className="p-4 text-center" data-id="element-108">1 jar</td>
              </tr>
              <tr className="border-b border-green-900/10 bg-green-900/5" data-id="element-109">
                <td className="p-4 text-green-900 font-semibold" data-id="element-110">25-50 lbs</td>
                <td className="p-4 text-center" data-id="element-111">1 chew</td>
                <td className="p-4 text-center" data-id="element-112">1 jar</td>
              </tr>
              <tr className="border-b border-green-900/10" data-id="element-113">
                <td className="p-4 text-green-900 font-semibold" data-id="element-114">50-75 lbs</td>
                <td className="p-4 text-center" data-id="element-115">1.5 chews</td>
                <td className="p-4 text-center" data-id="element-116">2 jars</td>
              </tr>
              <tr className="bg-green-900/5" data-id="element-117">
                <td className="p-4 text-green-900 font-semibold" data-id="element-118">
                  Over 75 lbs
                </td>
                <td className="p-4 text-center" data-id="element-119">2 chews</td>
                <td className="p-4 text-center" data-id="element-120">2 jars</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="flex justify-center" data-id="element-121">
          <a href="#malnutrition" className="bg-yellow-700 hover:bg-yellow-800 text-amber-50 font-bold py-3 px-8 rounded-full text-lg shadow-md transition duration-300 inline-block" data-id="element-122">
            CALCULATE MY DOG'S DOSE
          </a>
        </div>
      </div>
    </section>;
};